import React from 'react';
import TabDataIcon from '../../../Icons/TabDataStatus'

type Props = {
  values: any
};

const SettingsData = (props: Props) => {
  if (props.values) {
    if (
      props.values.active ||
      props.values.name ||
      props.values.description ||
      props.values.publishers ||
      props.values.domains ||
      props.values.pace ||
      props.values.pace_type ||
      props.values.html_head ||
      props.values.targets
    ) {
      return (<TabDataIcon />);
    }
  }
  return null;
}

export default SettingsData;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/Helpers/TabData/SettingsTabData.tsx